<template>
  <el-card class="subscription-card">
    <el-tabs v-model="currentTab" type="" class="big-tabs">
      <el-tab-pane label="订阅新游资讯" name="2" />
      <el-tab-pane label="订阅活动资讯" name="1" />
    </el-tabs>

    <div class="tab-content">
      <!-- 当前订阅展示 -->
      <div v-if="currentSub" class="current-sub">
        <h1>当前订阅</h1>
        <el-row :gutter="20" justify="center" class="sub-info">
          <el-col :span="8" style="text-align: left;font-size: 18px;min-width: 50%">
            <p>推送平台：{{ mapPlatform(currentSub.platform) }}</p>
            <p>
              推送玩法：
              {{ currentSub.gameplay_type }}
              {{ mapRank(currentSub.gameplay_rank) === '全部玩法' ? '排名不限' : mapRank(currentSub.gameplay_rank) }}
              {{ currentSub.gameplay_name }}
            </p>
            <p>推送方式：{{ mapPush(currentSub.push_method) }}</p>
            <p v-if="currentSub.push_method === 1">
              每日推送时间：{{ currentSub.scheduled_hour }} 点
            </p>
            <p>推送时长：{{ currentSub.duration_days }} 天</p>
            <p>到期时间：{{ currentSub.end_date }}</p>
          </el-col>
        </el-row>
        <el-divider />
      </div>

      <!-- 编辑／创建订阅表单 -->
      <el-form label-width="120px" class="edit-form">
        <!-- 玩法选择，仅"活动资讯"（type=1）显示 -->
        <template v-if="currentTab === '1'">
          <h2>选择玩法</h2>
          <el-form-item label="玩法类型：" >
            <el-button @click="showTypeDialog = true">
              {{ form.gameplay_type.length ? form.gameplay_type.join('，') : '全部' }}
            </el-button>
            <el-dialog
                title="玩法类型"
                v-model="showTypeDialog"
                width="30%"
            >
              <el-checkbox-group v-model="form.gameplay_type">
                <el-checkbox
                    v-for="opt in gameplayTypesOptions"
                    :key="opt"
                    :label="opt"
                >{{ opt }}</el-checkbox>
              </el-checkbox-group>
              <template #footer>
                <el-button @click="showTypeDialog = false">取 消</el-button>
                <el-button type="primary" @click="showTypeDialog = false">
                  确 定
                </el-button>
              </template>
            </el-dialog>
          </el-form-item>

          <el-form-item label="畅销榜排名：">
            <el-button @click="showRankDialog = true">
              {{ mapRank(form.gameplay_rank) }}
            </el-button>
            <el-dialog title="畅销榜排名" v-model="showRankDialog">
              <el-radio-group v-model="form.gameplay_rank" class="rank-vertical">
                <el-radio
                    v-for="opt in rankOptions"
                    :key="opt.value"
                    :label="opt.value"
                >{{ opt.label }}</el-radio>
              </el-radio-group>
              <template #footer>
                <el-button @click="showRankDialog = false">取 消</el-button>
                <el-button type="primary" @click="showRankDialog = false">
                  确 定
                </el-button>
              </template>
            </el-dialog>
          </el-form-item>

          <el-form-item label="玩法名称：">
            <el-button @click="showNameDialog = true">
              {{ form.gameplay_name.length
                ? form.gameplay_name.join('，')
                : '请选择或输入' }}
            </el-button>
            <el-dialog title="玩法名称" v-model="showNameDialog" width="60%">
              <div class="selected-tags">
                <el-tag
                    v-for="(g, idx) in form.gameplay_name"
                    :key="idx"
                    closable
                    @close="() => form.gameplay_name.splice(idx, 1)"
                >{{ g }}</el-tag>
              </div>
              <!-- 自定义搜索框 -->
              <div class="custom-autocomplete">
                <input
                    v-model="searchQuery"
                    type="text"
                    placeholder="请输入玩法名"
                    @focus="showSuggestions = true"
                    @input="onSearchInput"
                    @blur="() => setTimeout(() => (showSuggestions = false), 200)"
                    class="autocomplete-input"
                />
                <ul
                    v-if="showSuggestions && filteredSuggestions.length"
                    class="autocomplete-dropdown"
                >
                  <li
                      v-for="item in filteredSuggestions"
                      :key="item.value"
                      @click="onGameSelect(item)"
                  >{{ item.label }}</li>
                </ul>
              </div>
              <template #footer>
                <el-button @click="showNameDialog = false">取 消</el-button>
                <el-button type="primary" @click="showNameDialog = false">
                  确 定
                </el-button>
              </template>
            </el-dialog>
          </el-form-item>
        </template>

        <!-- 推送方式 -->
        <h2>推送方式</h2>
        <el-form-item>
          <el-radio-group v-model="form.push_method" class="vertical-radio">
            <el-radio :label="0">上线立即推送</el-radio>
            <label class="radio-with-input">
              <el-radio :label="1">每日定时推送</el-radio>
              <el-input
                  v-model="form.scheduled_hour"
                  :min="0"
                  :max="23"
                  class="inline-input"
              />
              <span>点推送</span>
            </label>
          </el-radio-group>
        </el-form-item>

        <!-- 订阅时长 -->
        <h2>订阅时长</h2>
        <el-form-item>
          <el-radio-group v-model="form.durationOption" class="vertical-radio">
            <el-radio :label="30">一个月</el-radio>
            <el-radio :label="90">三个月</el-radio>
            <label class="radio-with-input">
              <el-radio :label="'custom'">自定义时长</el-radio>
              <el-input
                  v-model="form.customDays"
                  :min="30"
                  :max="365"
                  class="inline-input"
              />
              <span>天</span>
            </label>
          </el-radio-group>
        </el-form-item>

        <!-- 提交按钮 -->
        <el-form-item>
          <el-button type="primary" @click="submit">
            {{ currentSub ? '确认修改' : '确认提交' }}
          </el-button>
          <el-button @click="goBack" style="margin-left: 10px;">返回</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-card>
</template>

<script setup>
import { ref, reactive, onMounted, watch, computed } from 'vue'
import axios from 'axios'
import { ElMessage } from 'element-plus'

const API_BASE = 'https://www.hudongwanfa.cn'

// 所有订阅列表
const subscriptions = ref([])
// 当前标签页（'2'=新游、'1'=活动）
const currentTab = ref('2')

// 下拉对话框展示控制
const showTypeDialog = ref(false)
const showRankDialog = ref(false)
const showNameDialog = ref(false)

// 搜索及自动补全
const searchQuery = ref('')
const showSuggestions = ref(false)
const filteredSuggestions = ref([])

// 可选项
const gameplayTypesOptions = [
  '荐','热','对战','角力','攻防','比赛',
  '竞速','养成','闯关','整蛊','乱斗','音舞','全部'
]
const rankOptions = [
  { label: '全部玩法', value: 0 },
  { label: '三月内前20名', value: 1 },
  { label: '三月内前50名', value: 2 },
]

// 表单数据
const form = reactive({
  type: 2,
  platform: 'dy',
  gameplay_type: [],
  gameplay_rank: 0,
  gameplay_name: [],
  push_method: 0,
  scheduled_hour: 0,
  durationOption: 30,
  customDays: null,
})

// 获取当前类型的订阅
const currentSub = computed(() =>
    subscriptions.value.find((s) => String(s.type) === currentTab.value)
)

// 标签切换或数据加载后初始化表单
function initForm() {
  form.type = Number(currentTab.value)
  if (currentSub.value) {
    const s = currentSub.value
    form.platform = s.platform
    form.gameplay_type = s.gameplay_type
        ? s.gameplay_type.split(',')
        : []
    form.gameplay_rank = s.gameplay_rank
    form.gameplay_name = s.gameplay_name
        ? s.gameplay_name.split(',')
        : []
    form.push_method = s.push_method
    form.scheduled_hour =
        s.push_method === 1 ? s.scheduled_hour : 0
    // 订阅时长
    if (s.duration_days === 30) {
      form.durationOption = 30
      form.customDays = null
    } else if (s.duration_days === 90) {
      form.durationOption = 90
      form.customDays = null
    } else {
      form.durationOption = 'custom'
      form.customDays = s.duration_days
    }
  } else {
    // 默认
    form.platform = 'dy'
    form.gameplay_type = []
    form.gameplay_rank = 0
    form.gameplay_name = []
    form.push_method = 0
    form.scheduled_hour = 0
    form.durationOption = 30
    form.customDays = null
  }
}

watch(currentTab, initForm)

// 页面加载：读取 openid + 拉取订阅数据
onMounted(async () => {
  try {
    const res = await axios.get(
        `${API_BASE}/wechat/subscription`,
    )
    if (res.data.success) {
      subscriptions.value = res.data.subscriptions
    }
  } catch {
    ElMessage.error('获取订阅信息失败')
  } finally {
    initForm()
  }
})

// 地图函数
function mapPlatform(v) {
  return v === 'dy' ? '抖音' : '快手'
}
function mapRank(v) {
  return (
      rankOptions.find((r) => r.value === v)?.label || ''
  )
}
function mapPush(v) {
  return v === 0 ? '立即' : '每日定时'
}

// 游戏自动补全
async function onSearchInput() {
  const q = searchQuery.value.trim()
  if (!q) {
    filteredSuggestions.value = []
    return
  }
  try {
    const resp = await axios.get(
        'https://www.hudongwanfa.cn/api/search_game',
        { params: { game_name: q } }
    )
    filteredSuggestions.value = resp.data.data.map((it) => ({
      label: it.game_name,
      value: it.game_name,
    }))
  } catch (e) {
    console.error(e)
  }
}
function onGameSelect(item) {
  if (!form.gameplay_name.includes(item.value)) {
    form.gameplay_name.push(item.value)
  }
  searchQuery.value = ''
  filteredSuggestions.value = []
}

// 提交／更新
async function submit() {
  // 处理订阅时长天数
  form.duration_days =
      form.durationOption === 'custom'
          ? form.customDays
          : form.durationOption

  // 计算结束日期
  const d = new Date()
  d.setDate(d.getDate() + form.duration_days)
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  const end_date = `${y}-${m}-${day}`

  const payload = {
    type: form.type,
    platform: form.platform,
    gameplay_type: form.gameplay_type.join(','),
    gameplay_rank: form.gameplay_rank,
    gameplay_name: form.gameplay_name.join(','),
    push_method: form.push_method,
    scheduled_hour:
        form.push_method === 1 ? form.scheduled_hour : 0,
    duration_days: form.duration_days,
    end_date,
  }

  try {
    const r = await axios.post(
        `${API_BASE}/wechat/subscription`,
        payload
    )
    if (r.data.success) {
      ElMessage.success('提交成功')
      // 更新本地
      subscriptions.value = subscriptions.value.filter(
          (s) => String(s.type) !== currentTab.value
      )
      subscriptions.value.push(r.data.subscription)
      initForm()
    } else {
      ElMessage.error(r.data.message || '提交失败')
    }
  } catch {
    ElMessage.error('网络错误，提交失败')
  }
}

// 返回
function goBack() {
  window.history.back()
}
</script>

<style scoped>

/* 1. Tabs 样式 */
.big-tabs ::v-deep .el-tabs__header {
  display: flex;
}
.big-tabs ::v-deep .el-tabs__header .el-tabs__item {
  flex: 1;
  width: 50%;
  text-align: center;
  font-size: 32px;
  padding: 24px;
}

/* 2. 推送方式 & 订阅时长 垂直排列 */
.vertical-radio {
  display: flex;
  flex-direction: column;
  align-items: start;
}
.vertical-radio .el-radio {
  margin-bottom: 8px;
}

/* 3. 行内输入框对齐 */
.radio-with-input {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: normal;
  margin-bottom: 0; /* 覆盖 el-radio 下面的 margin */
}
.inline-input {
  width: 80px;
  margin: 0 8px;
}

.subscription-card {
  max-width: 100%;
  margin: 40px auto;
  padding: 20px;
}
.tab-content {
  margin-top: 20px;
}
.sub-info {
  text-align: center;
  margin-bottom: 20px;
}
.edit-form h4 {
  margin-top: 20px;
  color: #333;
}
.custom-autocomplete {
  position: relative;
  min-width: 300px;
}
.autocomplete-input {
  width: 100%;
  padding: 6px 8px;
  box-sizing: border-box;
}
.autocomplete-dropdown {
  position: absolute;
  top: 36px;
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #ebeef5;
  max-height: 200px;
  overflow-y: auto;
  z-index: 10;
}
.autocomplete-dropdown li {
  padding: 6px 8px;
  cursor: pointer;
}
.autocomplete-dropdown li:hover {
  background: #f5f7fa;
}
.selected-tags {
  margin-bottom: 10px;
}
.el-card {
  background: #ffffffaf;
}

.el-radio /deep/ .el-radio__label {
  font-size: 18px;
}

/* 让所有 radio 的文字 18px */
:deep(.el-radio__label) {
  font-size: 18px;
}

:deep(.el-checkbox__label) {
  font-size: 18px;
}

/* 让所有 el-button 的文字 18px（包括对话框按钮和表单里的按钮） */
:deep(.el-button),
:deep(.el-button__text) {
  font-size: 18px;
}

/* “点推送” / “天” 文字也设为 18px */
.radio-with-input span {
  font-size: 18px;
}

/* 如果你还想让 input-number 里的数字也稍大一点： */
.inline-input input {
  font-size: 18px;
}

/* 所有 el-form-item label 文字 18px */
:deep(.el-form-item__label),
:deep(.el-form-item label) {
  font-size: 18px;
}

/* 让整个 radio-group 纵向排列 */
::v-deep(.rank-vertical) {
  display: flex !important;
  flex-direction: column !important;
}

/* 把每个 radio 拉开间距 */
::v-deep(.rank-vertical) .el-radio {
  margin-bottom: 8px;
}

/* 2. 放大 selected-tags 中的 el-tag */
.selected-tags :deep(.el-tag) {
  font-size: 18px;
  margin-right: 8px;
}

/* 3. 给 el-tag 的叉号图标换色，确保醒目 */
.selected-tags :deep(.el-tag .el-tag__close) {
  color: #f56c6c !important;      /* 你可以换成你喜欢的高对比色 */
  font-size: 14px;     /* 视需要放大一点 */
}

</style>
